import { Purchase, PurchaseStatus } from '../../models/payment.models';

export const getIsRefundButtonVisible = (purchase?: Purchase) => {
  if (!purchase) return false;

  const isPurchaseFree = purchase.total === 0;
  const isRefundRequested = purchase.refundRequested;
  const isPurchaseCanceled =
    purchase.status === PurchaseStatus.Error ||
    purchase.status === PurchaseStatus.Canceled;
  const isPurchaseWaitingToBePayed = purchase.status === PurchaseStatus.New;

  if (
    isPurchaseFree ||
    isRefundRequested ||
    isPurchaseCanceled ||
    isPurchaseWaitingToBePayed
  ) {
    return false;
  }

  return true;
};

export const getIsHelpButtonVisible = (purchase?: Purchase) => {
  if (!purchase) return false;

  const isPurchaseCanceled =
    purchase.status === PurchaseStatus.Error ||
    purchase.status === PurchaseStatus.Canceled;
  const isPurchaseWaitingToBePayed = purchase.status === PurchaseStatus.New;

  if (isPurchaseCanceled) return false;
  if (isPurchaseWaitingToBePayed) return false;

  return true;
};
